
  import tData from './components/data.vue';
  import BsMixin from '@/views/Home/mixins/bsMixin';
  import {Mixins, Component} from "vue-property-decorator";
  import {Button, Collapse, CollapseItem, Option, Select} from "element-ui";
  import bModal from "../course/components/bModal.vue";
  @Component({
    components: {
      Collapse,
      CollapseItem,
      Option,
      Select,
      Button,
      tData,
      bModal,
    },
  })
  export default class normal extends Mixins(BsMixin) {
  }
